$(function() {
    // Wait for autofill
    setTimeout(function(){
        $('.text-input__input:-webkit-autofill').each(function(key, elem) {
            $(elem).addClass('text-input__input--filled');
        });
    });
});

$(document).on('blur', '.text-input__input', function () {
    if(this.value)
        $(this).addClass('text-input__input--filled');
    else
        $(this).removeClass('text-input__input--filled');
});